import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const LabelPrintingService = {
  async load(transactionType, transactionNo) {
    var url = "api/InventoryLabelPrint/Load?transactionType=" + transactionType + "&transactionNo=" + transactionNo;
    return await ApiService.get(url);
  },
  async save(payload) {
    return await ApiService.post("api/InventoryLabelPrint", payload);
  }
};

export { LabelPrintingService };
